import React from "react";
import Size from "shared/enums/Size";
import ManageOrgAdminTable from "./table";
import { Outlet } from "react-router-dom";
import Button from "shared/components/button";
import useManageOrgAdminService from "./service";
import { useCopies } from "shared/hooks/useCopies";
import { Modal, ModalBody, ModalHeader } from "shared/components/modal";

export default function ManageOrgAdminModal() {
  const copies = useCopies();
  const tableRef = React.useRef<any>();
  const service = useManageOrgAdminService();

  return (
    <React.Fragment>
      <Modal size={Size.FULL_WIDTH} className="manageOrgAdmin_modal">
        <ModalHeader left={copies.get("manage.org.admin")} onClose={service.closeManageOrgAdminHandler} />
        <ModalBody>
          <div className="manageOrgAdmin_actions">
            <div className="manageOrgAdmin_actions_searchBox modal_searchBox">{tableRef?.current?.SearchBox}</div>
            <div className="manageOrgAdmin_actions_btns">
              <Button label={copies.get("create.org.admin")} onClick={service.createOrgAdminHandler} />
            </div>
          </div>
          <ManageOrgAdminTable list={service.participantList} tableRef={tableRef} />
        </ModalBody>
      </Modal>
      <Outlet context={{ refetch: service.refetch }} />
    </React.Fragment>
  );
}
